import React from 'react';
import PropTypes, { any } from 'prop-types';

import GenderFilter from '../Filters/GenderFilter';
import DivisionFilter from '../Filters/DivisionFilter';
import ConferenceFilter from '../Filters/ConferenceFilter';
import CollegeUtrFitFilter from '../Filters/CollegeUtrFitFilter';
import CollegesMoreMobileFilter from '../Filters/CollegesMoreMobileFilter';
import useStartPowerCheckout from '../../../components/hooks/useStartPowerCheckout';

import { PowerFunnelSurfaces } from '../../../components/Analytics/constants';
import { getGatedFeatureForFilter, shouldGateCollegeFilter } from '../../../components/Analytics/helpers';

const CollegeFilters = (props) => {
    const {
        search,
        handleFilterClick,
        state,
        userLoggedIn,
        isPowerUser,
        _this,
        filterInputs,
        searchTypes,
        clearFilters,
    } = props;

    const { filters = {} } = search;

    const commonFilterProps = {
        filters,
        filterInputs,
        handleFilterClick,
        filterModal: state.filterModal,
        closeModals: _this.closeModals,
        handleFilterSubmit: _this.handleFilterSubmit,
        clearFilters,
        handleFilterUpdate: _this.handleFilterUpdate,
    };

    const { startPowerCheckout } = useStartPowerCheckout();

    const handleShowPowerPopup = (filterName) => {
        startPowerCheckout({
            surface: PowerFunnelSurfaces.COLLEGE_SEARCH_PAGE,
            gatedFeature: getGatedFeatureForFilter(filterName),
            confirmResume: true,
        });
    };

    const handleOnFilterClick = (filterName) => {
        const shouldGate = shouldGateCollegeFilter({
            filterName,
            isPowerUser,
            isProCollegeClubOrganizer: userLoggedIn?.isProCollegeClubOrganizer,
        });
        if (shouldGate) {
            handleShowPowerPopup(filterName);
        } else {
            handleFilterClick(filterName);
        }
    };

    return (
        <React.Fragment>
            <GenderFilter
                {...commonFilterProps}
                data-testid="search.colleges.filter.gender"
            />
            {userLoggedIn && (
                <DivisionFilter
                    {...commonFilterProps}
                    handleFilterClick={handleOnFilterClick}
                    searchTypes={searchTypes}
                    desktopOnly={true}
                    data-testid="search.colleges.filter.division"
                />
            )}
            {userLoggedIn && (
                <ConferenceFilter
                    {...commonFilterProps}
                    handleFilterClick={handleOnFilterClick}
                    searchTypes={searchTypes}
                    desktopOnly={true}
                    data-testid="search.colleges.filter.conference"
                />
            )}
            <CollegeUtrFitFilter
                {...commonFilterProps}
                userLoggedIn={userLoggedIn}
                handleFilterClick={handleOnFilterClick}
                data-testid="search.colleges.filter.utr-fit"
            />
            <CollegesMoreMobileFilter
                {...commonFilterProps}
                searchTypes={searchTypes}
                handleFilterClick={handleOnFilterClick}
                mobileOnly={true}
                data-testid="search.colleges.filter.more-mobile"
            />
        </React.Fragment>
    );
};

CollegeFilters.propTypes = {
    search: PropTypes.objectOf(any).isRequired,
    handleFilterClick: PropTypes.func.isRequired,
    state: PropTypes.objectOf(any).isRequired,
    userLoggedIn: PropTypes.objectOf(any).isRequired,
    isPowerUser: PropTypes.bool.isRequired,
    _this: PropTypes.objectOf(any).isRequired,
    filterInputs: PropTypes.objectOf(any).isRequired,
    searchTypes: PropTypes.objectOf(any).isRequired,
    clearFilters: PropTypes.func.isRequired,
};

export default CollegeFilters;
